import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import { ArticleWithRelations } from '@/models/request';

import { BaseMessage } from './BaseMessage';
import { GoToShipment } from './GoToShipment';

export const PrepareShipmentTaskMessage = ({ article }: { article: ArticleWithRelations }) => {
  const destinationName = article.toEntity?.name;

  return (
    <BaseMessage
      article={article}
      title={<Trans id="article.task.prepare-shipment.title">Ship the package</Trans>}
      message={
        <Stack gap="0.5rem" alignItems="flex-start">
          <p>
            {article.toClient && (
              <Trans id="article.task.prepare-shipment.text.to-client">
                Finish creating the shipment to send the item to the client.
              </Trans>
            )}
            {!!destinationName && (
              <Trans id="article.task.prepare-shipment.text.to-entity">
                Finish creating the shipment to send the item to {destinationName}.
              </Trans>
            )}
          </p>
          <GoToShipment article={article} />
        </Stack>
      }
    />
  );
};
